import React from 'react';
import { Star } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
export function Testimonials() {
  const testimonials = [{
    name: 'Luz Marina Carmona',
    initials: 'LM',
    quote: 'Antes de entrar al programa improvisaba cada set y vivía con miedo a los levantamientos. Después de aplicar el método de preparación que enseña María Clara, mis sets duran el doble y mis clientas me recomiendan solas. En 6 semanas subí mis precios un 40% y no perdí ni una clienta.'
  }, {
    name: 'Paola Andrea González',
    initials: 'PA',
    quote: 'Empecé sin saber nada de torno y le tenía miedo. Hoy es mi herramienta favorita. Aprendí desde cero con el método paso a paso y hoy mis ingresos se triplicaron. Mi agenda está llena y mi cartera de clientas crece todos los días.'
  }];
  return <SectionWrapper bg="blush" data-id="element-269">
      <div className="max-w-4xl mx-auto" data-id="element-270">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-warm-dark mb-12" data-id="element-271">
          Lo que dicen nuestras alumnas
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-272">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-2xl p-8 shadow-soft border-l-4 border-rose relative" data-id="element-273">
              <div className="flex gap-1 mb-4" data-id="element-274">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-275" />)}
              </div>

              <blockquote className="text-warm-muted italic mb-8 leading-relaxed" data-id="element-276">
                "{t.quote}"
              </blockquote>

              <div className="flex items-center gap-4 mt-auto" data-id="element-277">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-rose to-rose-light flex items-center justify-center text-white font-bold font-serif shadow-sm" data-id="element-278">
                  {t.initials}
                </div>
                <div data-id="element-279">
                  <p className="font-bold text-warm-dark" data-id="element-280">{t.name}</p>
                  <p className="text-xs text-warm-muted uppercase tracking-wider" data-id="element-281">
                    Alumna Certificada
                  </p>
                </div>
              </div>

              {/* Placeholder for student work photo */}
              <div className="mt-6 pt-6 border-t border-cream flex items-center gap-3" data-id="element-282">
                <div className="w-16 h-16 rounded-lg bg-cream border border-blush flex items-center justify-center" data-id="element-283">
                  <span className="text-[10px] text-warm-muted text-center px-1" data-id="element-284">
                    Foto Trabajo
                  </span>
                </div>
                <p className="text-sm text-warm-muted italic" data-id="element-285">
                  Resultados reales aplicando el método
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}